import React from "react";
import ListViewTable from "../../../../../shared/components/ListViewTable";
import { TableColumns } from "../../../../../configs/productOrder";
import { ProductOrderRow } from "../../../../ProductOrders/Content/ProductOrderTable";

const TopProductOrdersTable = () => {
    return (
        <ListViewTable
            url="/dashboard/sales-orders/?latest=5"
            rowElement={ProductOrderRow}
            tableColumns={TableColumns}
            subTitleText="Đơn hàng sản phẩm mới nhất"
        />
    );
};

export default TopProductOrdersTable;
